import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer"
import { InvoiceHistoryState } from "@preferredMedical/Store/Pages/InvoiceHistory/InvoiceHistoryState";
import { Draft } from "immer";

const initialState: InvoiceHistoryState = {
    selectedInvoices: [],
}

const reducer = {
    "Custom/Pages/InvoiceHistory/SetInvoiceIsSelected": (
        draft: Draft<InvoiceHistoryState>, 
        action: { invoiceNumber: string; amount: number; isSelected: boolean }) => {
        if(action.isSelected){
            draft.selectedInvoices = draft.selectedInvoices.concat([{invoiceNumber: action.invoiceNumber, amount: action.amount}]);
        }else {
            draft.selectedInvoices = draft.selectedInvoices.filter(i => i.invoiceNumber !== action.invoiceNumber);
        }
    },
    "Custom/Pages/InvoiceHistory/ClearSelectedInvoices": (
        draft: Draft<InvoiceHistoryState>) => {
        draft.selectedInvoices = [];
    }
}

export default createTypedReducerWithImmer(initialState, reducer);